import {
  AttachedImage,
  Box,
  ReportSection,
  ReportSectionItemContent,
  Text,
} from '@/components';
import type { LedgerRelatedMaterialSectionProps } from '@/features/mold/models/ledger';
import { type FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { LEDGER_BORDER, LEDGER_PADDING } from '../../../utils';

export const RelatedMaterialSection: FC<LedgerRelatedMaterialSectionProps> = ({
  relatedMaterials,
}) => {
  const { t } = useTranslation();

  const relatedMaterialImages =
    relatedMaterials?.flatMap((relatedMaterial) =>
      relatedMaterial.attachments.flatMap((image) => image.url ?? []),
    ) ?? [];

  return (
    <div>
      <ReportSection
        title={t('related-material')}
        items={[
          {
            wrapperStyle: {
              breakInside: 'initial',
              borderLeft: 'none',
              borderBottom: 'none',
            },
            item: (
              <Box>
                {relatedMaterialImages.length > 0 ? (
                  <ReportSectionItemContent
                    wrapperStyle={{ borderBottom: 'none' }}
                    value={
                      <Fragment>
                        {relatedMaterialImages.map((image, idx) => (
                          <AttachedImage
                            wrapperStyle={{
                              maxHeight: 'calc(210mm - 100px)',
                            }}
                            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                            key={idx}
                            src={image}
                            alt="related-material-image"
                          />
                        ))}
                      </Fragment>
                    }
                  />
                ) : null}
                <ReportSectionItemContent
                  wrapperStyle={{
                    borderTop: relatedMaterialImages.length
                      ? LEDGER_BORDER
                      : undefined,
                    borderLeft: 'none',
                    breakInside: 'avoid',
                    flexDirection: 'column',
                  }}
                  labelStyle={{
                    width: '100%',
                    borderLeft: 'none',
                    borderRight: 'none',
                    borderBottom: LEDGER_BORDER,
                  }}
                  value={
                    <Box padding={LEDGER_PADDING}>
                      <Text
                        variant="footnote"
                        text={relatedMaterials?.[0]?.additionalExplanation}
                      />
                    </Box>
                  }
                />
              </Box>
            ),
          },
        ]}
      />
    </div>
  );
};
